import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";
import { ClientProfile } from "@/model/data/authentication/ClientProfile";
import { ClientUser } from "@/model/data/authentication/ClientUser";

export class GetUsersStatisticsResData extends ApiGenericResponse {
    totalUsers: number;
    totalProfiles: number;
    monthlyActiveUsers: number;
    dailyActiveUsers: number;
    emptyProfiles: ClientProfile[];
    inactiveUsers: Map<ClientUser, Date>;

    constructor(response: AxiosResponse) {
        super(response);

        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.TotalUsers != null && obj.TotalUsers != undefined) this.totalUsers = obj.TotalUsers;
        if (obj.TotalProfiles != null && obj.TotalProfiles != undefined) this.totalProfiles = obj.TotalProfiles;
        if (obj.MonthlyActiveUsers != null && obj.MonthlyActiveUsers != undefined) this.monthlyActiveUsers = obj.MonthlyActiveUsers;
        if (obj.DailyActiveUsers != null && obj.DailyActiveUsers != undefined) this.dailyActiveUsers = obj.DailyActiveUsers;
        if (obj.EmptyProfiles) {
            this.emptyProfiles = new Array<ClientProfile>();
            obj.EmptyProfiles.forEach((profile) => {
                this.emptyProfiles.push(ClientProfile.parseFrom(profile));
            });
        }
        if (obj.InactiveUsers) {
            this.inactiveUsers = new Map<ClientUser, Date>();
            obj.InactiveUsers.forEach((user: any) => {
                this.inactiveUsers.set(ClientUser.parseFrom(user), obj.InactiveUsersLastLogin[user.Name]);
            });
        }
    }
}
